'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var _rollupPluginBabelHelpers = require('../../../../_virtual/_rollupPluginBabelHelpers.js');
var React = require('react');
var React__default = _interopDefault(React);
var PropTypes = _interopDefault(require('prop-types'));
require('../../00.helper/Code/index.js');
require('../../00.helper/FormField/index.js');
require('../../00.helper/Icons/Icons.js');
require('../../00.helper/Link/Link.js');
var classNames = _interopDefault(require('classnames/dedupe'));
var PageLayer = require('../../00.helper/PageLayer/PageLayer.js');
var ButtonLink = require('../../01.atoms/ButtonLink/ButtonLink.js');
var ButtonPlain = require('../../01.atoms/ButtonPlain/ButtonPlain.js');
var Headline = require('../../01.atoms/Headline/Headline.js');
var Img = require('../../01.atoms/Img/Img.js');
var RichText = require('../../01.atoms/RichText/RichText.js');
require('./_index.scss.js');

var CLASSNAME = 'varta-text-image-cta',
    cnOverlay = "".concat(CLASSNAME, "--overlay"),
    cnCta = "".concat(CLASSNAME, "--cta"),
    cnHoverEffect = "".concat(CLASSNAME, "--hover-effect"),
    cnLink = "".concat(CLASSNAME, "__link"),
    cnImageWrapper = "".concat(CLASSNAME, "__image-wrapper"),
    cnImage = "".concat(CLASSNAME, "__image"),
    cnMirror = "".concat(CLASSNAME, "--mirror"),
    cnContentWrapper = "".concat(CLASSNAME, "__content-wrapper"),
    cnContentWrapperOverlay = "".concat(cnContentWrapper, "--overlay"),
    cnContent = "".concat(CLASSNAME, "__content"),
    cnImageWrapperOverlay = "".concat(cnImageWrapper, "--overlay"),
    cnHeadline = "".concat(CLASSNAME, "__headline"),
    cnText = "".concat(CLASSNAME, "__text"),
    cnButton = "".concat(CLASSNAME, "__button"),
    cnRow = "".concat(CLASSNAME, "__row");
/**
 * 
 */

var TextImageCta = /*#__PURE__*/function (_React$Component) {
  _rollupPluginBabelHelpers.inherits(TextImageCta, _React$Component);

  var _super = _rollupPluginBabelHelpers.createSuper(TextImageCta);

  function TextImageCta() {
    _rollupPluginBabelHelpers.classCallCheck(this, TextImageCta);

    return _super.apply(this, arguments);
  }

  _rollupPluginBabelHelpers.createClass(TextImageCta, [{
    key: "render",
    value: function render() {
      var _classNames;

      var _this$props = this.props,
          headline = _this$props.headline,
          text = _this$props.text,
          headlineLevel = _this$props.headlineLevel,
          link = _this$props.link,
          cta = _this$props.cta,
          srcset = _this$props.srcset,
          title = _this$props.title,
          iconId = _this$props.iconId,
          iconPosition = _this$props.iconPosition,
          disabled = _this$props.disabled,
          overlay = _this$props.overlay,
          className = _this$props.className,
          onClick = _this$props.onClick,
          target = _this$props.target,
          style = _this$props.style,
          animate = _this$props.animate,
          mirror = _this$props.mirror,
          classes = [className, CLASSNAME, "".concat(CLASSNAME, "--").concat(style)],
          linkWholeTeaser = link && !text;
      return /*#__PURE__*/React__default.createElement("div", {
        className: classNames(classes, (_classNames = {}, _rollupPluginBabelHelpers.defineProperty(_classNames, cnMirror, mirror), _rollupPluginBabelHelpers.defineProperty(_classNames, cnOverlay, overlay), _rollupPluginBabelHelpers.defineProperty(_classNames, cnCta, cta), _rollupPluginBabelHelpers.defineProperty(_classNames, cnHoverEffect, !title && !cta && linkWholeTeaser), _rollupPluginBabelHelpers.defineProperty(_classNames, "".concat(CLASSNAME, "--link"), linkWholeTeaser), _classNames)),
        onClick: linkWholeTeaser ? function () {
          window.open(link.as, '_blank');
        } : null
      }, /*#__PURE__*/React__default.createElement(PageLayer, {
        noBackground: true
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames(cnRow)
      }, /*#__PURE__*/React__default.createElement("div", {
        className: classNames(cnImageWrapper, _rollupPluginBabelHelpers.defineProperty({}, cnImageWrapperOverlay, overlay))
      }, /*#__PURE__*/React__default.createElement(Img, {
        className: cnImage,
        srcset: srcset,
        alt: headline,
        animate: animate
      })), /*#__PURE__*/React__default.createElement("div", {
        className: classNames(cnContentWrapper, _rollupPluginBabelHelpers.defineProperty({}, cnContentWrapperOverlay, overlay))
      }, /*#__PURE__*/React__default.createElement("div", {
        className: cnContent
      }, /*#__PURE__*/React__default.createElement(Headline, {
        className: cnHeadline,
        level: headlineLevel
      }, headline), text && /*#__PURE__*/React__default.createElement(RichText, {
        className: cnText,
        content: text
      }), link && cta && overlay && /*#__PURE__*/React__default.createElement(ButtonPlain, {
        className: cnButton,
        link: link,
        title: title,
        disabled: disabled,
        onClick: onClick,
        target: target,
        type: !overlay ? 'secondary' : undefined,
        iconId: iconId || !title && 'hero-arrow-right',
        iconPosition: iconPosition
      }), link && (!cta || !overlay) && /*#__PURE__*/React__default.createElement(ButtonLink, {
        bold: true,
        className: classNames(cnLink, "".concat(cnLink, "--").concat(style)),
        link: link,
        iconId: iconId || !title && 'hero-arrow-right',
        title: title,
        disabled: disabled,
        onClick: onClick,
        iconPosition: iconPosition
      }))))));
    }
  }]);

  return TextImageCta;
}(React__default.Component);
TextImageCta.propTypes = {
  /** Add scroll-in animation to image */
  animate: PropTypes.bool,

  /** Additional class name */
  className: PropTypes.string,

  /** Render link as CTA button */
  cta: PropTypes.bool,

  /** True if disabled */
  disabled: PropTypes.bool,

  /** Leve of headline e.g. 1 for h1 */
  headlineLevel: PropTypes.number,

  /** Title string */
  headline: PropTypes.string,

  /** Add custom icon to the link */
  iconId: PropTypes.string,

  /** Options for icon position */
  iconPosition: PropTypes.oneOf(['after', 'before']),

  /** URL to link to */
  link: PropTypes.string,

  /** Switch order of image <=> text */
  mirror: PropTypes.bool,

  /** Callback function */
  onClick: PropTypes.func,

  /** Indent content to it overlays image */
  overlay: PropTypes.bool,

  /** Images in different sizes */
  srcset: PropTypes.shape({
    xs: PropTypes.string.isRequired,
    sm: PropTypes.string,
    md: PropTypes.string,
    lg: PropTypes.string,
    xl: PropTypes.string,
    xxl: PropTypes.string
  }).isRequired,

  /** Render as light or dark component */
  style: PropTypes.oneOf(['dark', 'light']),

  /** Specifies where to open the linked document. Ignored if `link` is not provided */
  target: PropTypes.string,

  /** Content text */
  text: PropTypes.string,

  /** Button label */
  title: PropTypes.string
};
TextImageCta.defaultProps = {
  style: 'white',
  headlineLevel: 3,
  iconPosition: 'after',
  onClick: function onClick() {
    return void 0;
  }
};

module.exports = TextImageCta;
